import React, { useState } from "react";

import { Row, Col, Alert, Container } from "reactstrap";

import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import logoSvg from "../../assets/images/logo-sm.jpeg";
import banner from "../../assets/images/banner.jpeg";
import Loading from "../../components/loading/Loading";
import { useHistory } from "react-router";
import { postLogin } from "../../services/SharedServices";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { login } = useAuth();

  // handleValidSubmit
  const handleValidSubmit = async (values: any) => {
    setLoading(true);
    try {
      let response = await postLogin(values);
      login(response.data.data, response.data.data.token);
      history.push("/");
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.data?.message) {
        setError(error?.response?.data?.message);
      } else {
        setError(`Ocurrió un error al procesar la solicitud, reintentar`);
      }
    }
  };

  return (
    <React.Fragment>
      {loading && <Loading />}
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <Link to="/" className="d-block auth-logo">
                        <img
                          src={logoSvg}
                          alt=""
                          height="auto"
                          style={{ width: "100%" }}
                        />
                      </Link>
                    </div>
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h5 className="mb-0">Bienvenido de nuevo!</h5>
                        <p className="text-muted mt-2">
                          Iniciar sesión en el panel
                        </p>
                      </div>
                      <AvForm
                        className="custom-form mt-4 pt-2"
                        onValidSubmit={(e: any, v: any) => {
                          handleValidSubmit(v);
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        <div className="mb-3">
                          <AvField
                            name="email"
                            label="Email"
                            value=""
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <label className="form-label">Password</label>
                            </div>
                          </div>

                          <div className="mb-3">
                            <AvField
                              name="password"
                              value=""
                              type="password"
                              className="form-control"
                              required
                              placeholder="Enter Password"
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <button
                            className="btn btn-primary w-100 waves-effect waves-light"
                            type="submit"
                          >
                            Login
                          </button>
                        </div>
                      </AvForm>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <div className="col-xxl-9 col-lg-8 col-md-7">
              <img
                src={banner}
                alt=""
                height="100%"
                width="100%"
                style={{ objectFit: "cover", objectPosition: "right" }}
              />
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
